import { Order } from "@/types/order";
import { Customer } from "@/types/user";
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import toast from "react-hot-toast";

export const userApi = createApi({
  reducerPath: "userApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${import.meta.env.VITE_API_BASE_URL}api/`,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("access_token");
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    generateOtp: builder.mutation<void, { phone: string }>({
      query: (body) => ({
        url: "generate-otp",
        method: "POST",
        body,
      }),
      onQueryStarted: async (_, { queryFulfilled }) => {
        try {
          const res = await queryFulfilled;
          if (res.meta?.response?.status === 200) {
            toast.success("OTP sent successfully");
          }
        } catch (error) {
          toast.error("Failed to send OTP");
          console.error(error);
        }
      },
    }),
    verifyOtp: builder.mutation<
      {
        user: Customer;
      },
      { phone: string; otp: string }
    >({
      query: (body) => ({
        url: "verify-otp",
        method: "POST",
        body,
      }),
      onQueryStarted: async (_, { queryFulfilled }) => {
        try {
          const res = await queryFulfilled;
          if (res.meta?.response?.status === 200) {
            toast.success("OTP verified successfully");
          }
        } catch (error) {
          toast.error("Failed to verify OTP");
          console.error(error);
        }
      },
    }),
    fetchCustomerPoints: builder.query<
      {
        points: string;
      },
      {
        phone: string;
        branch: string;
      }
    >({
      query: ({ phone, branch }) =>
        `fetch-customer-points?phone=${phone}&branch=${branch}`,
    }),
    updateCustomerProfile: builder.mutation({
      query: (body) => ({
        url: "customer-profile",
        method: "POST",
        body,
      }),
      onQueryStarted: async (_, { queryFulfilled }) => {
        try {
          const res = await queryFulfilled;
          if (res.meta?.response?.status === 200) {
            toast.success("Profile updated successfully");
          }
        } catch (error) {
          toast.error("Failed to update profile");
          console.error(error);
        }
      },
    }),
  }),
});

export const {
  useGenerateOtpMutation,
  useVerifyOtpMutation,
  useFetchCustomerPointsQuery,
  useUpdateCustomerProfileMutation,
} = userApi;
